function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import Button from '@doordash/component-button';
import Modal from './Modal';
import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash.omit';

var Confirm = function Confirm(_ref) {
  var dismissText = _ref.dismissText,
      onDismiss = _ref.onDismiss,
      confirmText = _ref.confirmText,
      onConfirm = _ref.onConfirm,
      confirmButtonProps = _ref.confirmButtonProps,
      dismissButtonProps = _ref.dismissButtonProps,
      props = _objectWithoutProperties(_ref, ["dismissText", "onDismiss", "confirmText", "onConfirm", "confirmButtonProps", "dismissButtonProps"]);

  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    size: Modal.Sizes.Small,
    role: "alertdialog",
    isFullScreenOnMobile: false,
    hasCloseButton: false,
    shouldCloseOnOverlayClick: false,
    primaryAction: {
      text: confirmText,
      onClick: onConfirm,
      buttonProps: _objectSpread({}, confirmButtonProps)
    },
    secondaryAction: {
      text: dismissText,
      onClick: onDismiss,
      buttonProps: _objectSpread({}, dismissButtonProps)
    }
  }));
};

Confirm.propTypes = _objectSpread(_objectSpread({}, omit(Modal.propTypes, ['secondaryAction', 'primaryAction', 'hasCloseButton', 'actionsFillContainer', 'size'])), {}, {
  confirmText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  dismissText: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  confirmButtonProps: PropTypes.object,
  dismissButtonProps: PropTypes.object
});
Confirm.defaultProps = {
  dismissText: 'Cancel',
  confirmText: 'Confirm',
  confirmButtonProps: {
    type: Button.defaultProps.type
  },
  dismissButtonProps: {
    type: Button.Types.FlatSecondary
  }
};
export default Confirm;